// extracted by mini-css-extract-plugin
export default {"ContainerRow":"styles_ContainerRow__w26ZK"};